import React, { useState, useEffect } from 'react'
import { Card, Col, Container } from 'reactstrap'
// actions
import { getSurveyCategories } from "../../../store/catalogs/SurveyCategories/actions"
import { getSurveyConcepts, updateSurveyConcept, addNewSurveyConcept, deleteSurveyConcept, updateSurveyConceptStatus } from "../../../store/catalogs/SurveyConcepts/actions"
import { useSelector, useDispatch, shallowEqual } from "react-redux";

import Table1 from "../../../components/Common/TableContainer"
import { SearchBar } from '../../../components/Common/SearchBar'
import { BackButton } from '../../../components/Common/BackButton'
import { NewRegisterButton } from '../../../components/Common/NewRegisterButton'
import Breadcrumb from '../../../components/Common/Breadcrumb'
import { TableItemDeleteModal } from '../../../components/Common/TableItemDeleteModal'
import { ToastContainer } from 'react-toastify'
import { SurveyConceptRegisterModal } from './SurveyConceptRegisterModal';
import "react-toastify/dist/ReactToastify.css"

export const CatalogLayoutConceptQuiz = (props) => {

    const [showModal1, setShowModal1] = useState(false);
    const [showModal2, setShowModal2] = useState(false);

    // Modal HOOKS
    const [isUpdate, setIsUpdate] = useState(false);
    const [rowInfo, setRowInfo] = useState();

    const [searchData, setSearchData] = useState('');

    // * Redux
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(getSurveyConcepts(`?limit=20&page=0&search=${searchData}`))
    }, [searchData, dispatch])

    useEffect(() => {
        dispatch(getSurveyCategories("?limit=1000&page=0"))
        dispatch(getSurveyConcepts("?limit=20&page=0"))
    }, [dispatch])

    const { surveyConcepts, loading, total, currentPage, surveyCategories } = useSelector(state => ({
        surveyConcepts: state.surveyConceptsReducer.surveyConcepts,
        loading: state.surveyConceptsReducer.loading,
        surveyConcept: state.surveyConceptsReducer.surveyConcept,
        total: state.surveyConceptsReducer.total,
        currentPage: state.surveyConceptsReducer.currentPage,
        surveyCategories: state.surveyCategoriesReducer.surveyCategories,
    }), shallowEqual);
    // * Redux fin

    const columns = React.useMemo(
        () => [
            {
                Header: 'Categoría',
                width: '40%',
                Cell: ({ row }) => (
                    <div>
                        <div className='text-left'>{row.original.surveyCategory.name ?? '-'}</div>
                    </div>
                ),
            },
            {
                Header: 'Concepto',
                width: '35%',
                Cell: ({ row }) => (
                    <div>
                        <div className='text-left'>{row.original.concept ?? '-'}</div>
                    </div>
                ),
            },
            {
                Header: 'Estatus',
                width: "15%",
                Cell: ({ row }) => (
                    row.original.recordStatus === true ?
                        <div className='text-success'>Activo</div> :
                        <div className='text-danger'>Inactivo</div>
                ),
            },
            {
                width: '10%',
                Header: "Acciones",
                Cell: ({ row }) => (
                    <div className="page-title-box d-flex align-items-center justify-content-center">
                        <button className="btn btn-outline-secondary text-primary mx-1 rounded-3 p-0 me-2" onClick={() => { onUpdate(row.original) }}> <span className="mdi mdi-18px mdi-lead-pencil p-2"></span> </button>
                        <button className="btn btn-outline-secondary text-danger mx-1 rounded-3 p-0" onClick={() => { onDelete(row.original) }}> <span className="mdi mdi-18px mdi-delete p-2"></span> </button>
                    </div>
                ),
            },
        ],
        []
    )

    const onUpdate = (values) => {
        setIsUpdate(true)
        setRowInfo(values)
        setShowModal1(true)
    }

    const onDelete = (values) => {
        setRowInfo(values)
        setShowModal2(true)
    }

    const getPagination = (params) => {
        dispatch(getSurveyConcepts(`${params}&search=${searchData}`))
    }

    const onDeleteConfirmation = () => {
        dispatch(deleteSurveyConcept(rowInfo))
        setRowInfo('')
    }

    const RegisterModalRespInfo = (values, active) => {
        if (isUpdate) {
            const updValue = { ...values, id: rowInfo.id }
            dispatch(updateSurveyConcept(updValue))
            dispatch(updateSurveyConceptStatus({
                id: rowInfo.id,
                recordStatus: active,
            }));
            setTimeout(() => {
                dispatch(getSurveyConcepts("?limit=20&page=0"))
            },400)
        } else {
            dispatch(addNewSurveyConcept(values))
        }
        setIsUpdate(false)
        setRowInfo('')
    }

    const modalClose = () => {
        setIsUpdate(false)
    }

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid className="" >
                    <Col className="col-12" style={{ padding: 40 }}>
                        <Card className='' style={{ padding: 20 }}>

                            <Breadcrumb breadcrumbItem1='catalogsmenu' breadcrumbItem2='ConceptQuizCatalog' />

                            <Card className='' style={{ padding: 20 }}>

                                <div className='pe-1'>
                                    <BackButton props={props} />
                                </div>

                                <div className="row">
                                    <div className="col-12 col-sm-12 col-md-12 col-lg-9 col-xl-9col-xxl-9 mb-2 ps-3 pe-3">
                                        <SearchBar setSearchData={setSearchData} />
                                    </div>
                                    <div className="col-12 col-sm-12 col-md-12 col-lg-3 col-xl-3 col-xxl-3 pe-3">
                                        <NewRegisterButton setShowModal={setShowModal1} showModal={showModal1} />
                                    </div>
                                </div>

                                <div className='ms-1'>
                                    <Table1 currentPage={currentPage} getPagination={getPagination} total={total} loading={loading} isAddTableBorderStrap columns={columns} data={surveyConcepts} />
                                </div>

                                <SurveyConceptRegisterModal
                                    surveyCategories={surveyCategories}
                                    rowInfo={rowInfo}
                                    modalClose={modalClose}
                                    isUpdate={isUpdate}
                                    modalRespInfo={RegisterModalRespInfo}
                                    setShowModal={setShowModal1}
                                    showModal={showModal1}
                                />

                                <TableItemDeleteModal onDeleteConfirmation={onDeleteConfirmation} props={props} setShowModal={setShowModal2} showModal={showModal2} modalHeader='Eliminar concepto' modalBodyLabel='¿Está seguro que desea cambiar el estatus del concepto de encuesta de satisfacción seleccionada?' />

                            </Card>

                            <br />
                            <br />

                        </Card>
                    </Col>
                    <ToastContainer autoClose={2000} newestOnTop={true} />

                </Container>
            </div>
        </React.Fragment>
    )
}
